import { useCookie } from '#composables/nuxt';

/**
 * 楽天アフィリエイトのカスタムヘッダーを生成する
 * @returns 楽天アフィリエイト用のHTTPヘッダーオブジェクト
 */
export function buildRakutenAffiliateHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};

  // NuxtのuseCookieを使用してCookieから楽天アフィリエイトデータを取得
  const rakutenSiteId = useCookie('rakuten_siteID');
  const rakutenDateTime = useCookie('rakuten_datetime_entered');

  // 両方の値が存在する場合のみヘッダーに追加
  if (rakutenSiteId.value && rakutenDateTime.value) {
    headers['X-Rakuten-Site-ID'] = rakutenSiteId.value;
    headers['X-Rakuten-DateTime-Entered'] = rakutenDateTime.value;
  }

  return headers;
}
